import { type UniversalSearchScope } from '@terros/common'
import { type MaterialSymbolType } from '@front/model'

export const SEARCH_ENTITY_ICONS = new Map<UniversalSearchScope, MaterialSymbolType>([
  ['Account', 'home'],
  ['Calendar', 'event'],
  ['User', 'person'],
  ['Team', 'groups'],
  ['Company', 'business'],
])
